<agpr-take-over-panel
    [id]="id"
    header="AMT.apiKeys.management.title"
    [responsiveWidth]="true"
    [minPanelWidth]="880"
    [maxPanelWidth]="880"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="onVisibleChange($event)"
>
    <div
        class="agpr-manage-api-keys"
        [agprLoading]="isLoading"
    >
        <!-- Left: list panel -->
        <div
            class="agpr-manage-api-keys-list"
            [class.agpr-manage-api-keys-list--empty]="apiKeys.length === 0 && !isLoading"
        >
            @if (!isLoading && apiKeys.length > 0) {
                <div class="agpr-manage-api-keys-list-header">
                    <span class="agpr-manage-api-keys-list-header-title">
                        {{ 'AMT.apiKeys.management.apiKeys' | localize }}
                    </span>
                    <div class="agpr-manage-api-keys-list-header-actions">
                        <div class="agpr-manageSources-sort">
                            <agpr-button
                                [id]="id + '_sortDirection'"
                                [style]="buttonTypes.icon"
                                [icon]="sourceGroupSortOrder === sortOrder.ascending ? 'fa-regular fa-arrow-down-short-wide' : 'fa-regular fa-arrow-up-wide-short'"
                                [tooltip]="'SourceGroups.sort'"
                                tooltipPosition="top"
                                (click)="toggleSourceGroupSortOrder()"
                            ></agpr-button>
                            <agpr-icon-dropdown
                                [id]="id + '_sortOption'"
                                [options]="sourceGroupSortMenuOptions"
                                [applyHighlight]="true"
                                [alignPanelRight]="true"
                                inputTooltip="SourceGroups.sort.options"
                                inputTooltipPosition="top"
                                [(ngModel)]="selectedSourceGroupSortOption"
                                (ngModelChange)="sortSourceGroups($event)"
                            ></agpr-icon-dropdown>
                        </div>
                        <agpr-button
                            [id]="id + '_create'"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="AMT.apiKeys.management.create"
                            tooltipPosition="top"
                            (click)="startCreate()"
                        ></agpr-button>
                    </div>
                </div>
                <agpr-scroll-panel #keyListScrollPanel>
                    <ul class="agpr-manage-api-keys-list-items">
                        @for (key of apiKeys; track key.id; let i = $index) {
                            <li
                                #keyItem
                                class="agpr-manage-api-keys-list-item agpr-contextMenu-parent"
                                [class.agpr-manage-api-keys-list-item--selected]="selectedKey?.id === key.id && !isCreating"
                                [attr.data-id]="key.id"
                                (click)="selectKey(key)"
                            >
                                <span class="agpr-manage-api-keys-list-item-accent"></span>

                                <div class="agpr-manage-api-keys-list-item-info">
                                    <div
                                        class="agpr-manage-api-keys-list-item-name"
                                        [agprTooltip]="key.name"
                                        [tooltipPosition]="'top'"
                                    >
                                        {{ key.name }}
                                    </div>
                                    <div
                                        class="agpr-manage-api-keys-list-item-keyId"
                                        [agprTooltip]="key.id + ''"
                                        [tooltipPosition]="'top'"
                                    >
                                        {{ 'AMT.apiKeys.management.keyId' | localize }}: {{ key.id }}
                                    </div>
                                    <div class="agpr-manage-api-keys-badge">
                                        {{ (key.disabled ? 'AMT.apiKeys.management.suspended' : 'AMT.apiKeys.management.active') | localize }}
                                    </div>
                                </div>

                                <div class="agpr-contextMenu bottom right">
                                    <agpr-button
                                        [id]="id + '_key_' + i + (key.disabled ? 'activate' : 'suspend')"
                                        class="agpr-manage-api-keys-list-item-button"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="key.disabled ? 'fa-duotone fa-regular fa-play' : 'fa-duotone fa-regular fa-pause'"
                                        [tooltip]="key.disabled ? 'AMT.apiKeys.management.activate' : 'AMT.apiKeys.management.suspend'"
                                        [tooltipPosition]="'top'"
                                        (click)="updateKeyStatus(key)"
                                    ></agpr-button>
                                </div>

                            </li>
                        }
                    </ul>
                </agpr-scroll-panel>
            }
        </div>

        <!-- Right: details / create panel -->
        <div class="agpr-manage-api-keys-details">
            <agpr-scroll-panel>
                @if (!isLoading && apiKeys.length === 0) {
                    <!-- Landing Page - No API Keys -->
                    <div class="agpr-manage-api-keys-details-empty">
                        <span class="agpr-manage-api-keys-details-empty-icon fa-duotone fa-regular fa-key"></span>
                        <p class="agpr-manage-api-keys-details-empty-text">
                            {{ 'AMT.apiKeys.management.emptyState' | localize }}
                        </p>
                    </div>
                    <ng-container *ngTemplateOutlet="createCard"></ng-container>
                } @else if (isCreating) {
                    <!-- Create API Key -->
                    <h3 class="agpr-manage-api-keys-details-section-title">
                        {{ 'AMT.apiKeys.management.create' | localize }}
                    </h3>
                    <ng-container *ngTemplateOutlet="createCard"></ng-container>

                } @else if (selectedKey) {
                    <!-- Edit API Key -->
                    <h3 class="agpr-manage-api-keys-details-section-title">
                        {{ 'AMT.apiKeys.management.details' | localize }}
                    </h3>
                    <div class="agpr-manage-api-keys-details-field">
                        <agpr-text-input
                            [id]="id + '_name_input'"
                            label="AMT.apiKeys.management.keyName"
                            [(ngModel)]="selectedKey.name"
                            (change)="updateKey()"
                            [bottomMargin]="false"
                            [maxLength]="100"
                            [required]="true"
                        ></agpr-text-input>
                        @if (!selectedKey.name?.trim()) {
                            <agpr-form-message [id]="id + '_error_requiredName'" [marginBottom]="0">
                                {{ 'AMT.apiKeys.management.keyName.required' | localize }}
                            </agpr-form-message>
                        }
                    </div>
                    <div class="agpr-manage-api-keys-details-field">
                        <div class="agpr-manage-api-keys-details-label">
                            {{ 'AMT.apiKeys.management.apiKey' | localize }}
                        </div>
                        <div class="agpr-manage-api-keys-details-key-row">
                            <span class="agpr-manage-api-keys-details-key-text">
                                {{ showKeyValue ? selectedKey.keyValue : '********************************' }}
                            </span>
                            <agpr-button
                                [id]="id + '_showKey'"
                                [style]="buttonTypes.icon"
                                [icon]="showKeyValue ? 'fa-duotone fa-regular fa-eye-slash' :'fa-duotone fa-regular fa-eye'"
                                [tooltip]="showKeyValue ? 'AMT.apiKeys.management.hideKey' : 'AMT.apiKeys.management.showKey'"
                                (click)="toggleKeyVisibility()"
                            ></agpr-button>
                            @if(showKeyValue) {
                                <agpr-button
                                    [id]="id + '_copyKey'"
                                    [style]="buttonTypes.icon"
                                    icon="fa-duotone fa-regular fa-copy"
                                    tooltip="AMT.apiKeys.management.copyKey"
                                    (click)="copyKey()"
                                ></agpr-button>
                            }
                        </div>
                    </div>
                    <div class="agpr-manage-api-keys-details-field">
                        <div class="agpr-manage-api-keys-details-label">
                            {{ 'AMT.apiKeys.management.createdBy' | localize }}
                        </div>
                        <div>{{ selectedKey.createdBy }}</div>
                    </div>
                    <div class="agpr-manage-api-keys-details-field">
                        <div class="agpr-manage-api-keys-details-label">
                            {{ 'AMT.apiKeys.management.createdDate' | localize }}
                        </div>
                        <div>{{ selectedKey.createdDate | date: 'MMMM d, yyyy h:mm a' }}</div>
                    </div>
                    <div class="agpr-manage-api-keys-details-field">
                        <agpr-textarea-input
                            [id]="id + '_notes_textareaInput'"
                            label="AMT.apiKeys.management.notes"
                            placeholder="AMT.apiKeys.management.notes.placeholder"
                            [(ngModel)]="selectedKey.note"
                            (change)="updateKey()"
                            [rows]="3"
                            [maxLength]="250"
                        ></agpr-textarea-input>
                    </div>
                    <div class="agpr-manage-api-keys-badge">
                        {{ (selectedKey.disabled ? 'AMT.apiKeys.management.suspended' : 'AMT.apiKeys.management.active') | localize }}
                    </div>
                }
            </agpr-scroll-panel>
        </div>
    </div>

    <!-- Create Card Template -->
    <ng-template #createCard>
        <div class="agpr-manage-api-keys-details-card">
            <agpr-text-input
                [id]="id + '_createCard_input'"
                [label]="'AMT.apiKeys.management.keyName'"
                [placeholder]="'AMT.apiKeys.management.keyName.placeholder'"
                [(ngModel)]="newKeyName"
                [maxLength]="100"
            ></agpr-text-input>
            <div class="agpr-manage-api-keys-details-card-footer">
                <agpr-button
                    [id]="id + '_createCard_create'"
                    [style]="buttonTypes.primary"
                    label="AMT.apiKeys.management.create.button"
                    [disabled]="!newKeyName?.trim()"
                    (click)="createKey()"
                ></agpr-button>
            </div>
        </div>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_done'"
            [style]="buttonTypes.primary"
            label="done"
            (click)="close()"
        ></agpr-button>
    </ng-template>

</agpr-take-over-panel>
